export default __webpack_public_path__ + "static/media/garouscreendesk.80c8d617.png";